export const avatarDefaultUser = '/image/blank-avatar-user.svg'
export const avatarDefaultGroup = '/image/blank-avatar-group.svg'
export const noImage = '/image/No_image_available_500_x_500.svg'
export const defaultTitle = 'LMS Pedagogical INTelligence ARchitecture'